export enum EKGImportConstants {
  SET_MONITOR_OPTIONS = 'ekgImport/SET_MONITOR_OPTIONS',

  GET_POWER_ON_TIME_LIST_RESULTS = 'ekgImport/GET_POWER_ON_TIME_LIST_RESULTS',
  SET_POWER_ON_TIME_LIST_RESULTS = 'ekgImport/SET_POWER_ON_TIME_LIST_RESULTS',
  SET_SELECTED_POWER_ON_TIME = 'ekgImport/SET_SELECTED_POWER_ON_TIME',

  SET_FILTERED_FROM = 'ekgImport/SET_FILTERED_FROM',
  SET_FROM_TIME_OPTIONS = 'ekgImport/SET_FROM_TIME_OPTIONS',
  GET_FILTERED_FROM = 'ekgImport/GET_FILTERED_FROM',
  SET_FILTERED_MONITOR = 'ekgImport/SET_FILTERED_MONITOR',
  GET_FILTERED_MONITOR = 'ekgImport/GET_FILTERED_MONITOR',

  GET_EVENTS_AND_REPORTS_RESULTS = 'ekgImport/GET_EVENTS_AND_REPORTS_RESULTS',
  SET_EVENTS_LIST_RESULTS = 'ekgImport/SET_EVENTS_LIST_RESULTS',
  SET_REPORTS_LIST_RESULTS = 'ekgImport/SET_REPORTS_LIST_RESULTS',

  SET_SELECTED_EVENTS = 'ekgImport/SET_SELECTED_EVENTS',

  SET_SELECTED_REPORTS = 'ekgImport/SET_SELECTED_REPORTS',

  SET_VISITED_REPORTS = 'ekgImport/SET_VISITED_REPORTS',
  GET_REPORT_IMAGE = 'ekgImport/GET_REPORT_IMAGE',
  GET_REPORT_ATTACHMENT_IMAGE = 'ekgImport/GET_REPORT_ATTACHMENT_IMAGE',
  UPDATE_REPORTS_LIST = 'ekgImport/UPDATE_REPORTS_LIST',

  SAVE_EKG_IMPORT_DATA = 'ekgImport/SAVE_EKG_IMPORT_DATA',
  GET_REPORT_ATTACHMENTS = 'ekgImport/GET_REPORT_ATTACHMENTS',
  SAVE_REPORT_ATTACHMENTS = 'ekgImport/SAVE_REPORT_ATTACHMENTS',
  DELETE_REPORT_ATTACHMENT = 'ekgImport/DELETE_REPORT_ATTACHMENT',

  SET_CURRENT_PROCEDURE = 'ekgImport/SET_CURRENT_PROCEDURE',
  SET_PROCEDURE_EVENTS = 'ekgImport/SET_PROCEDURE_EVENTS',

  CREATE_MEDICATION_PROCEDURE = 'ekgImport/CREATE_MEDICATION_PROCEDURE',
  CREATE_AIRWAY_PROCEDURE = 'ekgImport/CREATE_AIRWAY_PROCEDURE',
  CREATE_CRITICAL_CARE_PROCEDURE = 'ekgImport/CREATE_CRITICAL_CARE_PROCEDURE',
  CREATE_OPERATIONS_PROCEDURE = 'ekgImport/CREATE_OPERATIONS_PROCEDURE',
  CREATE_CARDIAC_PROCEDURE = 'ekgImport/CREATE_CARDIAC_PROCEDURE',
  CREATE_INTUBATION_PROCEDURE = 'ekgImport/CREATE_INTUBATION_PROCEDURE',
  CREATE_DRAIN_PROCEDURE = 'ekgImport/CREATE_DRAIN_PROCEDURE',
  CREATE_HOSPITAL_NOTIFY_PROCEDURE = 'ekgImport/CREATE_HOSPITAL_NOTIFY_PROCEDURE',
  CREATE_VENTILATOR_PROCEDURE = 'ekgImport/CREATE_VENTILATOR_PROCEDURE',
  CREATE_LABS_PROCEDURE = 'ekgImport/CREATE_LABS_PROCEDURE',
  CREATE_TITRATE_PROCEDURE = 'ekgImport/CREATE_TITRATE_PROCEDURE',
  CREATE_INITIATE_IV_PROCEDURE = 'ekgImport/CREATE_INITIATE_IV_PROCEDURE',

  RESET_EKG_AFTER_FLOW_COMPLETES = 'ekgImport/RESET_EKG_AFTER_FLOW_COMPLETES',
  RESET_EKG_AFTER_LEAVING_CHART = 'ekgImport/RESET_EKG_AFTER_LEAVING_CHART',
  RESET_EKG_AFTER_LEAVING_SERVICE = 'ekgImport/RESET_EKG_AFTER_LEAVING_SERVICE',
}
